import { addDays, format, startOfWeek } from "date-fns";

import { NumericalDayOfWeek } from "./types";

export const generateCalendarDayHeader = (
  clubWeekStartsOn: NumericalDayOfWeek,
  formatString: string = "EEEEEE",
  capitalize: boolean = false
) => {
  const startDate = startOfWeek(new Date(), { weekStartsOn: clubWeekStartsOn });
  return Array.from({ length: 7 }, (_, i) => {
    const formattedDay = format(addDays(startDate, i), formatString, {
      weekStartsOn: clubWeekStartsOn,
    });
    return capitalize ? formattedDay.toUpperCase() : formattedDay;
  });
};
